import { Box, Skeleton, Typography, pn } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { DevExpressReport } from 'components';
import { DashboardCard } from '../components/DashboardCard';
import { useGPAData } from '../contexts';
import { GPADistributionDto } from 'generated/openApi';
import { GPAFilterControls } from './GPAFilterControls';

export const GPATableCard = () => {
    const { data, loading, error } = useGPAData();
    return <DashboardCard title="GPA Distribution"><Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <GPAFilterControls />
        {loading ? <Skeleton variant="rounded" height={400} /> : error ? <Typography color="error" align="center">{error}</Typography> :
        <Box sx={{ flexGrow: 1, minHeight: 0 }}><DevExpressReport dataSource={data} fullPageSize showColumnChooser={false}>
            <Column dataField={pn<GPADistributionDto>('year')} caption="School Year" cellRender={({ value }) => `${value}-${value + 1}`} />
            <Column dataField={pn<GPADistributionDto>('schoolName')} caption="School" />
            <Column dataField={pn<GPADistributionDto>('gpaName')} caption="GPA Range" />
            <Column dataField={pn<GPADistributionDto>('studentCount')} caption="Students" />
            <Column dataField={pn<GPADistributionDto>('percentage')} caption="Percentage" cellRender={({ value }) => `${value}%`} />
        </DevExpressReport></Box>}
    </Box></DashboardCard>;
};
